import svgPanZoom from 'svg-pan-zoom';

const FloorplanZoom = () => {
  const btnFloorPlanZooms = document.querySelectorAll<HTMLButtonElement>(
    '.js-btn-floor-plan-zoom',
  );

  const floorPlanContainer = document.getElementById('js-floor-plan-container');

  if (btnFloorPlanZooms.length === 0 || !floorPlanContainer) {
    return;
  }

  let panZoomInstance: SvgPanZoom.Instance | null = null; // Allow null initialization
  let initialViewBox: string | null = null; // To store the initial viewBox

  const initZoomComponent = () => {
    const zoomSlider = document.getElementById(
      'zoomSlider',
    ) as HTMLInputElement;
    const floorPlanSVG = document.querySelector<SVGSVGElement>(
      '.floor-plan-images svg',
    );

    if (floorPlanSVG) {
      // Store the initial viewBox
      initialViewBox = floorPlanSVG.getAttribute('viewBox');

      // Initialize SVG Pan Zoom on the SVG element
      panZoomInstance = svgPanZoom(floorPlanSVG, {
        zoomEnabled: true,
        controlIconsEnabled: false,
        fit: true,
        center: true,
        minZoom: 0.5,
        maxZoom: 10,
        zoomScaleSensitivity: 0.1,
        onZoom: function (scale) {
          // Update the slider value based on zoom level
          if (zoomSlider) {
            zoomSlider.value = scale.toString(); // Set the slider to current zoom level
          }
        },
      });

      // Handle zoom slider input
      if (zoomSlider) {
        zoomSlider.addEventListener('input', () => {
          const zoomLevel = parseFloat(zoomSlider.value); // Parse the value from the slider
          if (panZoomInstance) {
            panZoomInstance.zoom(zoomLevel);
          }
        });
      }
    } else {
      console.error('Floor plan SVG element not found.');
    }
  };

  const destroyZoomComponent = () => {
    if (panZoomInstance) {
      panZoomInstance.reset();
      panZoomInstance.destroy();
      panZoomInstance = null; // Clear the instance reference

      const floorPlanSVG = document.querySelector<SVGSVGElement>(
        '.floor-plan-images svg',
      );

      if (floorPlanSVG && initialViewBox) {
        // Reset the SVG to its initial state
        floorPlanSVG.setAttribute('transform', ''); // Remove any applied transforms
        floorPlanSVG.setAttribute('viewBox', initialViewBox); // Reset the viewBox

        // Find the viewport group and reset its transform and style
        const viewportGroup = floorPlanSVG.querySelector<HTMLElement>(
          '.svg-pan-zoom_viewport',
        );
        if (viewportGroup) {
          console.log('vp', viewportGroup);
          viewportGroup.setAttribute('transform', 'matrix(1, 0, 0, 1, 0, 0)'); // Reset transform
          viewportGroup.removeAttribute('style'); // Remove inline styles if any
        }

        console.log('SVG reset to initial state.');
      }
    }
  };

  const init = () => {
    btnFloorPlanZooms.forEach(btn => {
      if (btn) {
        btn.addEventListener('click', () => {
          // Check if the button has the 'enlarge' class
          if (floorPlanContainer.classList.contains('enlarge')) {
            // Remove 'enlarge' class if it exists
            floorPlanContainer.classList.remove('enlarge');
            destroyZoomComponent();
          } else {
            // Add 'enlarge' class if it doesn't exist
            floorPlanContainer.classList.add('enlarge');
            initZoomComponent();
          }
        });
      }
    });
  };

  init();
};

export default FloorplanZoom;
